import { useEffect } from 'react'
import './Modal.css'

const Modal = ({ title, children, onClose }) => {
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.()
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [onClose])

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true">
      <div className="modal-sheet">
        <button className="modal-close" onClick={onClose} aria-label="Close">
          ✕
        </button>
        {title ? <h2 className="modal-title">{title}</h2> : null}
        <div className="modal-body">{children}</div>
      </div>
    </div>
  )
}

export default Modal

